<template>
    <header>
        <div class="items">
            <a href="/" class="logo__link__wrap"><img class="logo" src="/images/navigation/logo.webp" alt="GATE21"/></a>

            <ul class="links">
                <a href="/" :class="(this.current_page === 'home' ? 'active' : '')">
                    <p>HOME</p>
                    <span class="text_underline"></span>
                    <div class="span_bg"></div>
                </a>
                <!-- <a :href="(this.current_page === 'home') ? '' : '/'"> -->
                <a href="/projects" :class="(this.current_page === 'projects' ? 'active' : '')">
                    <p>PROJECTS</p>
                    <span class="text_underline"></span>
                    <div class="span_bg"></div>
                </a>
                <!-- <a :href="(this.current_page === 'home') ? '' : '/'"> -->
                <a href="/news" :class="(this.current_page === 'news' ? 'active' : '')">
                    <p>NEWS</p>
                    <span class="text_underline"></span>
                    <div class="span_bg"></div>
                </a>
                <!-- <a :href="(this.current_page === 'home') ? '' : '/'">
                    <p>OUR TEAM</p>
                    <span class="text_underline"></span>
                    <div class="span_bg"></div>
                </a> -->
                <a href="/contact" :class="(this.current_page === 'contact' ? 'active' : '')">
                    <p>CONTACT US</p>
                    <span class="text_underline"></span>
                    <div class="span_bg"></div>
                </a>
                <!-- <a :href="(this.current_page === 'home') ? '' : '/'"> -->
                <a href="/careers" :class="(this.current_page === 'careers' ? 'active' : '')">
                    <p>CAREERS</p>
                    <span class="text_underline"></span>
                    <div class="span_bg"></div>
                </a>
            </ul>

            <div class="thq_nordic">
                <img class="thq_logo" src="/images/navigation/thq_nordic.webp" alt="THQ Nordic"/>
                <p>FAMILY MEMBER</p>
            </div>
        </div>

        <div class="mobile__menu">
            <a class="mobile__logo__link__wrap" href="/"><img src="/images/navigation/logo.webp" class="logo-mobile" alt="GATE21"></a>

            <div class="thq-mobile-logo">
                <img class="thq_logo" src="/images/navigation/thq_nordic.webp" alt="THQ Nordic"/>
                <p>FAMILY MEMBER</p>
            </div>
            
            <button class="hamburger hamburger--collapse" id="menuIcon" type="button" @click="toggleMobileMenu()" title="menu">
                <span class="hamburger-box">
                    <span class="hamburger-inner"></span>
                </span>
            </button>
        </div>

        <div id="mobile__menu__items">
            <div class="wrapper">
                <a href="/" class="animate__menulink">HOME</a>
                <a href="/projects" class="animate__menulink">PROJECTS</a>
                <a href="/news" class="animate__menulink">NEWS</a>
                <a href="/contact" class="animate__menulink">CONTACT US</a>
                <a href="/careers" class="animate__menulink">CAREERS</a>
            </div>
        </div>
    </header>
</template>
<script>
    export default {
        data(){
            return {
                text: "Vue3 component.",
                current_page: null,
                mobile_menu_open: false,
            }
        },
        created(){
            if(window.location.pathname === '/'){
                this.current_page = 'home';
            }
            if(window.location.pathname === '/contact'){
                this.current_page = 'contact';
            }
            if(window.location.pathname.includes('projects')){
                this.current_page = 'projects';
            }
            if(window.location.pathname.includes('news')){
                this.current_page = 'news';
            }
            if(window.location.pathname.includes('careers')){
                this.current_page = 'careers';
            }
        },
        methods: {
            toggleMobileMenu(){
                const icon = document.getElementById('menuIcon');
                const menu = document.getElementById('mobile__menu__items');
                const menuitems = document.getElementsByClassName('animate__menulink');

                if(this.mobile_menu_open){
                    let timeout_delay = 500;

                    for (let index = (menuitems.length - 1); index >= 0; index--) {

                        const single_link = menuitems[index];

                        setTimeout(()=> {
                            single_link.classList.remove('appearing');
                        },timeout_delay + 300);

                        setTimeout(()=> {
                            single_link.classList.remove('animating');
                        },timeout_delay);
                        
                        timeout_delay+=150;
                    }
                   
                    this.mobile_menu_open = false;

                    setTimeout(() => {
                        icon.classList.remove('is-active');
                        menu.classList.remove('visible');
                    }, 1000);

                } else {
                    icon.classList.add('is-active');
                    menu.classList.add('visible');

                    let timeout_delay = 500;

                    for (let index = 0; index < menuitems.length; index++) {

                        const single_link = menuitems[index];

                        single_link.addEventListener('click', this.toggleMobileMenu)

                        setTimeout(()=> {
                            single_link.classList.add('animating');
                        },timeout_delay);

                        setTimeout(()=> {
                            single_link.classList.add('appearing');
                        },timeout_delay + 100);
                        
                        timeout_delay+=50;
                    }

                    this.mobile_menu_open = true;
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    /*!
    * Hamburgers
    * @description Tasty CSS-animated hamburgers
    * @author Jonathan Suh @jonsuh
    * @site https://jonsuh.com/hamburgers
    * @link https://github.com/jonsuh/hamburgers
    */
    .hamburger {
        // padding: 15px 15px;
        padding: 7px 7px;
        padding-top: 9px;
        display: inline-block;
        cursor: pointer;
        transition-property: opacity, filter;
        transition-duration: 0.15s;
        transition-timing-function: linear;
        font: inherit;
        color: inherit;
        text-transform: none;
        background-color: transparent;
        border: 0;
        margin: 0;
        overflow: visible; 
    }

    .hamburger-box {
        width: 40px;
        height: 24px;
        display: inline-block;
        position: relative; 
    }

    .hamburger-inner {
        display: block;
        top: 50%;
        margin-top: -2px; 
    }
    .hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {
        width: 40px;
        height: 4px;
        background-color: #fff;
        border-radius: 4px;
        position: absolute;
        transition-property: transform;
        transition-duration: 0.15s;
        transition-timing-function: ease; 
    }
    .hamburger-inner::before, .hamburger-inner::after {
        content: "";
        display: block; 
    }
    .hamburger-inner::before {
        top: -10px; 
    }
    .hamburger-inner::after {
        bottom: -10px; 
    }

    .hamburger:hover {
        // opacity: 0.7; 
    }

    .hamburger.is-active:hover {
        // opacity: 0.7; 
    }

    .hamburger.is-active .hamburger-inner,
    .hamburger.is-active .hamburger-inner::before,
    .hamburger.is-active .hamburger-inner::after {
        background-color: #fff; 
    }

    /*
    * Collapse
    */
    .hamburger--collapse .hamburger-inner {
        top: auto;
        bottom: 0;
        transition-duration: 0.13s;
        transition-delay: 0.13s;
        transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); 
    }
    .hamburger--collapse .hamburger-inner::after {
        top: -20px;
        transition: top 0.2s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1), opacity 0.1s linear; 
    }
    .hamburger--collapse .hamburger-inner::before {
        transition: top 0.12s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1), transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19); 
    }

    .hamburger--collapse.is-active .hamburger-inner {
        transform: translate3d(0, -10px, 0) rotate(-45deg);
        transition-delay: 0.22s;
        transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); 
    }

    .hamburger--collapse.is-active .hamburger-inner::after {
        top: 0;
        opacity: 0;
        transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), opacity 0.1s 0.22s linear; 
    }
    .hamburger--collapse.is-active .hamburger-inner::before {
        top: 0;
        transform: rotate(-90deg);
        transition: top 0.1s 0.16s cubic-bezier(0.33333, 0, 0.66667, 0.33333), transform 0.13s 0.25s cubic-bezier(0.215, 0.61, 0.355, 1); 
    }

    header{
        width: 100%;
        height: 92px;

        // background: url('/images/navigation/background_full.webp');
        background: url('/images/navigation/background_full_v2.webp');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;

        filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.25));

        display: block;
        position: fixed;
        top: 0;
        left: 0;
        // z-index: 5;
        z-index: 100;

        .items{
            width: 100%;
            height: 100%;
            // max-width: 1553px;
            // max-width: 1650px;
            display: flex;
            flex-direction: row;

            max-width: 1920px;

            margin-left: auto;
            margin-right: auto;

            .logo__link__wrap{
                display: inline-flex;
                height: 100%;
                margin-left: 207px;
                margin-right: auto;
            }

            img.logo{
                // 207
                display: block;
                height: 60px;
                width: 40px;
                margin-top: auto;
                margin-bottom: auto;
                // margin-left: 0;
            }

            ul.links{
                display: flex;
                flex-direction: row;
                margin-bottom: 6px;
                margin-top: auto;
                height: 100%;
                cursor: pointer;

                li, a{
                    width: 161px;
                    // width: 100%;
                    // max-width: 161px;
                    height: 100%;
                    max-height: 92px;
                    list-style: none;

                    transition: all .3s ease;
                    border-bottom: 2px solid transparent;
                    background: transparent;
                    position: relative;
                    overflow-y: hidden;


                    div.span_bg{
                        background: linear-gradient(90deg, #ED1163 0%, #5C2C90 96.27%);
                        height: 100%;
                        width: 100%;
                        transition: all .3s ease-in-out;
                        margin-top: auto;
                        margin-bottom: 0;
                        opacity: 0;

                        position: absolute;
                        bottom: -92px;
                    }

                    &:hover{
                        div.span_bg{
                            height: calc(100%);
                            bottom: 0;
                            opacity: 1;
                        }

                        p{
                            top: 50%;
                        }
                    }

                    &.active{
                        span.text_underline{
                            opacity: 1;
                        }
                    }

                    span.text_underline{
                        width: 100%;
                        height: 3px;
                        background-color: #ED1163;
                        opacity: 0;
                        transition: all .3s ease-in-out;
                        position: absolute;
                        top: 100%; right: 50%;
                        transform: translate(50%,-50%);
                    }

                    p{
                        font-family: 'DIN Next LT Pro Medium', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        // font-weight: 500;
                        font-size: 18px;
                        line-height: 22px;
                        text-align: center;

                        color: #FFFFFF;

                        margin-top: auto;
                        margin-bottom: 0;
                        margin-bottom: 0;

                        width: 100%;
                        position: absolute;
                        top: 76px; right: 50%;
                        transform: translate(50%,-50%);
                        z-index: 100;

                        transition: all .3s ease-in-out;
                    }
                }
            }

            .thq_nordic{
                display: flex;
                flex-direction: column;
                margin-left: auto;
                // margin-right: 0;
                margin-right: 160px;
                margin-top: auto;
                margin-bottom: auto;

                img.thq_logo{
                    // 160
                    display: block;
                    width: 159px;
                    height: 25px;
                    margin-bottom: 4px;
                }

                p{
                    font-family: 'DIN Next LT Pro Medium', Tahoma, Verdana, sans-serif;
                    font-style: normal;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 100%;
                    /* identical to box height, or 16px */

                    letter-spacing: 0.22em;
                    text-transform: uppercase;

                    color: #FFFFFF;
                    margin-bottom: 0;
                    margin-top: 0;

                }
            }

            
            
        }

        .mobile__menu{
            display: none;
            flex-direction: row;
            justify-content: space-between;
            padding: 9px 21px;
            width: calc(100% - 21px);

            .mobile__logo__link__wrap{
                display: inline-flex;
                height: 100%;
            }

            .logo-mobile{
                display: block;
                height: 40px;
                width: 27px;
            }

            .thq-mobile-logo{
                display: flex;
                flex-direction: column;
                margin-right: -10px;

                img{
                    display: block;
                    opacity: 0.75;
                    width: 77px;
                    height: 12px;
                    margin-top: auto;
                    margin-bottom: 2px;
                }

                p{
                    font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                    font-style: normal;
                    // font-weight: 700;
                    font-size: 10px;
                    line-height: 100%;
                    /* or 10px */

                    letter-spacing: 0.04em;
                    text-transform: uppercase;

                    color: #FFFFFF;

                    opacity: 0.75;
                    margin: 0;
                    margin-bottom: auto;
                }
            }

            #menuIcon{
                user-select: none;
                margin-right: 6px;
            }
        }

        #mobile__menu__items{
            display: block;
            background: #212121;
            opacity: 0.9;

            transition: all .5s ease;

            height: 0;
            overflow: hidden;

            &.visible{
                height: 225px;
                margin-top: -2px; // fix bug with spacing
            }
            
            .wrapper{
                display: flex;
                flex-direction: column;
                padding: 25px 0;


                a{
                    font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                    font-style: normal;
                    // font-weight: 400;
                    font-size: 20px;
                    line-height: 90%;
                    /* or 18px */

                    text-align: center;
                    text-decoration: none;

                    margin-bottom: 22px;

                    color: #FFFFFF;

                    &.animate__menulink{
                        transition: all .3s ease;
                        transform: translateX(-2000px);
                        opacity: 0;
                        color: black;

                        &.animating{
                            transform: translateX(0);
                        }

                        &.appearing{
                            opacity: 1;
                            color: #fff;
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 1750px) {
        header{
         
            .items{

                .links{
                    padding: 0;
                }

                .logo__link__wrap{
                    margin-left: 48px;
                }

                .thq_nordic{
                    margin-right: 48px;
                }
            }
            
        }
    }

    @media screen and (max-width: 1280px) {
        header{
            .items{
                // justify-content: space-between;

                ul.links{
                    margin-left: auto;
                    margin-right: auto;
                }

                .thq_nordic{
                    margin-left: 0;
                }
            }
        }
    }

    @media screen and (max-width: 836px) {

        header{
            height: 60px;
        }

        header .items{
            display: none;
        }

        header .mobile__menu{
            display: flex;
        }

        
    }
</style>